import { useMutation } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { testSendNotificationTemplate } from "../../api/apiNotificationTemplates";
import parseError from "../../utils/parseError";

export const useTestSendNotificationTemplate = () => {
    const mutation = useMutation({
        mutationFn: ({ id, data }) => testSendNotificationTemplate(id, data),
        onSuccess: (res) => {
            toast.success(res?.message || "Test email sent");
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to send test email");
        },
    });

    return mutation;
};
